import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6330e9af"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout" }
const _hoisted_2 = { class: "main-nav-bar" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, null, -1))
const _hoisted_4 = { class: "menu-buttons" }
const _hoisted_5 = { class: "menu-buttons menu-buttons-bottom" }
const _hoisted_6 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_AssetManagerComponent = _resolveComponent("AssetManagerComponent")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_a_button, {
            onClick: _ctx.gotoCampaigns,
            class: "menu-button",
            shape: "circle"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, {
                icon: "sliders-h",
                class: "menu-icon"
              })
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            onClick: _ctx.gotoManager,
            shape: "circle",
            class: "menu-button"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, {
                icon: "user",
                class: "menu-icon"
              })
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_a_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.logout())),
            class: "menu-button",
            shape: "circle"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, {
                icon: "power-off",
                class: "menu-icon"
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_router_view)
      ])
    ]),
    _createVNode(_component_a_modal, {
      footer: null,
      visible: _ctx.showModal,
      title: 'Assets',
      onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onCancel()))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AssetManagerComponent)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}